import { styled } from '@mui/system';
import { FC } from 'react';
import { useIcon } from '../../Hooks/useIcon';

interface EmergencyElemTitleProps {
  iconBackground: string;
  iconColor: string;
  icon: string;
  textColor: string;
  bgColor: string;
  padding?: string;
  title: string;
}

const RootDiv = styled('div')({
  marginTop: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const EmergencyElementHeaderDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const EmergencyElemBtnIconDiv = styled('div')({
  color: '#222',
  fontSize: '40px',
  backgroundColor: '#fff',
  padding: '9px',
  borderRadius: '50%',
  boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.5)',
  zIndex: 2,
});

const BtnTextDiv = styled('div')({
  color: '#fff',
  fontSize: '16px',
  textTransform: 'uppercase',
  backgroundColor: '#EE5961',
  padding: '5px 10px 7px 20px',
  marginLeft: '-10px',
  borderRadius: '4px',
  minWidth: '150px',
  zIndex: 1,
  wordBreak: 'break-all',
});

const EmergencyElemTitle: FC<EmergencyElemTitleProps> = ({
  iconBackground,
  iconColor,
  icon,
  textColor,
  bgColor,
  padding = '20px', // Default padding if not provided
  title,
}) => {
  return (
    <RootDiv>
      <EmergencyElementHeaderDiv>
        <EmergencyElemBtnIconDiv style={{ backgroundColor: iconBackground }}>
          <TitleIcon color={iconColor} iconName={icon} />
        </EmergencyElemBtnIconDiv>
        <BtnTextDiv
          style={{
            color: textColor,
            backgroundColor: bgColor,
            paddingLeft: padding,
          }}
        >
          {title}
        </BtnTextDiv>
      </EmergencyElementHeaderDiv>
    </RootDiv>
  );
};

export default EmergencyElemTitle;

interface TitleIconProps {
  color: string;
  iconName: string;
}

const TitleIcon: FC<TitleIconProps> = ({ color, iconName }) => {
  const Icon = useIcon({ color, iconName });
  return <>{Icon}</>;
};
